"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResponsiveOpen = function (_React$Component) {
    _inherits(ResponsiveOpen, _React$Component);

    function ResponsiveOpen() {
        _classCallCheck(this, ResponsiveOpen);

        return _possibleConstructorReturn(this, (ResponsiveOpen.__proto__ || Object.getPrototypeOf(ResponsiveOpen)).apply(this, arguments));
    }

    _createClass(ResponsiveOpen, [{
        key: "open",
        value: function open() {
            event.preventDefault(); // Just prevent the screen reload from the form actually submitting.
            document.getElementById("aside").style.display = "block";
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "navbar-item pull-left open", onClick: this.open },
                _react2.default.createElement(
                    "svg",
                    { viewBox: "0 0 24 24", className: "menu-reponsivo" },
                    _react2.default.createElement("path", { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" })
                )
            );
        }
    }]);

    return ResponsiveOpen;
}(_react2.default.Component);

exports.default = ResponsiveOpen;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/elements/ResponsiveOpen.js
// module id = 1114
// module chunks = 0